import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faMedal, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import './MyTrophies.css';

const API = process.env.REACT_APP_API_BASE_URL;
const PLACE = { 1: '1st place', 2: '2nd place', 3: '3rd place' };
const fmt = (s) => {
  const m = String(s || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? new Date(+m[1], +m[2] - 1, +m[3]).toLocaleDateString('en-US', { month: 'long', year: 'numeric' }) : '';
};

/* My Certificates page: competition trophies (shown only when the student has won one) */
const MyTrophies = () => {
  const [wins, setWins] = useState([]);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/api/student/competitions`, { headers: { Authorization: `Bearer ${localStorage.getItem('userData')}` } })
      .then((res) => !cancelled && setWins(res.data?.wins || []))
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!wins.length) return null;

  return (
    <section className="rmtr" aria-labelledby="rmtr-title">
      <div className="rmtr-head">
        <h2 id="rmtr-title">
          <FontAwesomeIcon icon={faTrophy} /> My trophies
        </h2>
        <Link to="/student/competitions">
          Competitions <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </div>
      <ul className="rmtr-list">
        {[...wins]
          .sort((a, b) => String(b.date).localeCompare(String(a.date)))
          .map((w, i) => (
            <li key={`${w.competition}-${i}`} className={`is-rank-${w.rank}`}>
              <span className="rmtr-medal" aria-hidden="true">
                <FontAwesomeIcon icon={w.rank === 1 ? faTrophy : faMedal} />
              </span>
              <b>{PLACE[w.rank]}</b>
              <span>{w.competition}</span>
              {fmt(w.date) && <small>{fmt(w.date)}</small>}
            </li>
          ))}
      </ul>
    </section>
  );
};

export default MyTrophies;
